module.exports = __webpack_public_path__ + "static/img/3.1a363db2.png";